import { ScenarioBuildStatusBase } from './base/scenario-build-status-base';

export class ScenarioBuildStatus extends ScenarioBuildStatusBase { }